import { apiClient } from './apiClient';

export const acceptInsuranceService = async (
    proxyBaseUrl: string,
    apiKey: string,
    arn: string | undefined,
    insuranceSelected: boolean,
): Promise<void> => {
    await apiClient<void>(`${proxyBaseUrl}/insurance/${arn}`, {
        method: 'PATCH',
        body: { insuranceSelected },
        apiKey,
        responseType: 'void',
        sentryTag: 'accept_insurance',
        sentryExtra: { arn },
    });
};
